import {
    HttpResponse,
    ShiftStationModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class ShiftStationsDataService implements CrudService<ShiftStationModel, ShiftStationModel> {
    getAll(query: CrudDataQuery<ShiftStationModel>): Promise<CrudEnumerableResponse<ShiftStationModel>> {
        return ApiService.api.getShiftStationBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ShiftStationModel>): Promise<CrudEnumerableResponse<ShiftStationModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ShiftStationModel>> {
        return ApiService.api.getShiftStationById(id, params);
    }

    create(item: ShiftStationModel, params?: RequestParams): Promise<CrudResponse<ShiftStationModel>> {
        return ApiService.api.insertShiftStation(item, params);
    }

    update(item: ShiftStationModel, params?: RequestParams): Promise<ShiftStationModel> {
        return ApiService.api.updateShiftStation(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ShiftStationModel> {
        return ApiService.api.patchShiftStation(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ShiftStationModel>): Promise<CrudEnumerableResponse<ShiftStationModel>> {
        return ApiService.api.deleteShiftStations(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationShiftStation(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<ShiftStationModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ShiftStationModel, params?: RequestParams): Promise<CrudResponse<ShiftStationModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getShiftStationGroupped(query, params);
    }

}
